

















































































































































































































import LayerPatternComponent from '../LayerPatternComponentV2'
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import {
  LayerPattern,
  Box,
  ProgramSettings,
  Pallet,
  BoxPosition,
  MachineSettings, PalletPattern, RobotTypeEnum, Sequence, Settings
} from '@/generated/model/models'
import * as layerTransform from '@/libs/layerTransform'
import { renumberBoxes } from '@/libs/pattern/layerSort'
import { ISnackbar } from '@/model'
import { PatternEditorState } from '@/libs/pattern/patternEditor'
import {
  checkPatternCompatibility,
  updateLayerIssues,
  setLayerIssuesValues,
  populateUniqueBoxIdsLayerPattern,
  populateUniqueBoxIds,
  getMaxBoxUID, getLayerPatternNameFromValidationDetails
} from '@/libs/pattern/layerPatternUtils'
import { isRI20 } from '@/libs/pattern/gripperUtils'
import { allBoxesInSequence, getCustomInfeedRotation } from '@/libs/pattern/sequenceUtils'
import { hasRightPalletModeOption } from '@/libs/pattern/robotUtils'
import { mapGetters } from 'vuex'
import {
  BoxLeadingMode,
  GeneratePatternPlanMessage,
  GeneratePatternPlanMessageTypeEnum, GeneratePlanResponse
} from '@/generated/websocketservice/model'

@Component({
  components: {
    LayerPatternComponent: LayerPatternComponent
  },
  computed: {
    ...mapGetters('settings', [ 'settings', 'isPatternGenerationEnabled']),
    ...mapGetters('patterngeneration', ['isPatternGenConnected', 'patternGenResponse'])
  }
})
export default class SimpleFormE extends Vue {
  @Prop({required: true}) private value!: Pallet
  @Prop({required: true}) private box!: Box
  @Prop({required: true}) private programSettings!: ProgramSettings
  @Prop({required: true}) private parentBus!: Vue
  @Prop({required: true}) private machineSettings!: MachineSettings
  @Prop({required: true}) private palletPattern!: PalletPattern

  private pallet: Pallet = JSON.parse(JSON.stringify(this.value))
  private layerPatterns: LayerPattern[] = this.pallet.layerPatterns!
  private activePattern: number = 0
  private valid: boolean = false
  private saving: boolean = false
  private showDefineLayerPatternDialog: boolean = false
  private snackbar: ISnackbar = {
    show: false,
    color: '',
    text: '',
    timeout: 10000
  }
  private rules: object = {
    required: (v: any) => !!v || 'Field is required'
  }
  private layerPatternComponentKey: number = 0
  private layerPatternComponentKeyAlt: number = 10000
  private activeSide: string = 'L'

  private shadowCache = {positions: [], groups: []}
  private modifiedAltLayers: number[] = []
  private reorderManuallyMode: boolean = false
  private boxOrientationOnConveyor = this.programSettings.boxOrientationOnConveyor
  private altIsModified: boolean = false
  private ignoreMachineSettings: boolean = false
  private showSettingsWarning: boolean = false
  private compatibilityIssues: string[] = []
  private showConfirmAutoRotate: boolean = false
  private canRotateAll: boolean = true

  private layerNames = ['A', 'B', 'Z']
  private hasLayerIssuesMap = new Map<string, number[]> ()
  private hasLayerIgnoredIssuesMap = new Map<string, number[]> ()
  private altHasIssues: boolean = false
  private altHasIgnoredIssues: boolean = false
  private leftHasIssues: boolean = false
  private leftHasIgnoredIssues: boolean = false
  private layerIssues = new Map<string, Array<{side: string, hasIssue: boolean, ignoredIssues: boolean}>>()
  private readonly defaultRightPalletMode: string = 'copy'
  private settings!: Settings
  private isPatternGenerationEnabled!: boolean
  private isPatternGenConnected!: boolean
  private patternGenResponse!: GeneratePlanResponse | null
  private selectedStrategy: string | null = null

  get form(): any {
    return this.$refs.dialogForm as any
  }

  get validAndNotInReorderManualMode() {
    return this.valid && !this.reorderManuallyMode && this.isPatternOk()
  }

  get lpcLeft(): any {
    return this.$refs.lpcLeft as any
  }

  get lpcRight(): any {
    return this.$refs.lpcRight as any
  }

  isPatternOk() {
    return this.isMachineSettingsOk() && this.hasValidSequences()
  }

  /**
   * Important! This creates two patterns: original and alternative. Alternative pattern looks the same as original,
   * but has a different ordering to let the robot build it on the opposite side/pallet.
   * Groups for the alternative pattern are not implemented, cause not solved yet.
   *
   * dataUrl is the base64 encoded string representation of the layer-pattern canvas image
   */
  savePattern(state: PatternEditorState, sequences?: Sequence[]) {
    console.log ('[DEBUG] left pattern saving ...')
    const boxPos = [...state.positions]
    const boxGroups = [...state.groups]
    const gripperSections = [...state.gripperSections]
    const pusherGroups = [...state.pusherGroups]
    const ignoreGripperBoxes = [...state.ignoreGripperBoxes]
    const ignoreRotationBoxes = [...state.ignoreRotationBoxes]

    const {modified, added} = this.getPositionsModified ([...boxPos], this.shadowCache.positions)
    const modifiedGroups = this.isGroupsModified ([...boxGroups], this.shadowCache.groups)

    this.layerPatterns[this.activePattern].boxPositions = boxPos
    this.layerPatterns[this.activePattern].boxGroups = boxGroups
    this.layerPatterns[this.activePattern].gripperSections = gripperSections
    this.layerPatterns[this.activePattern].pusher = pusherGroups
    this.layerPatterns[this.activePattern].ignoreGripper = ignoreGripperBoxes
    this.layerPatterns[this.activePattern].ignoreRotation = ignoreRotationBoxes
    if (this.isCustomSolution() && sequences !== undefined) {
      this.layerPatterns[this.activePattern].sequences = this.withDefaultSequenceApproach(sequences)
      this.layerPatterns[this.activePattern].boxPositionsAlt = []
    }

    let rightPalletMode
    if (hasRightPalletModeOption(this.programSettings.robotType!)) {
      rightPalletMode = (this.layerPatterns[this.activePattern].rightPalletMode) ? this.layerPatterns[this.activePattern].rightPalletMode!
          : this.defaultRightPalletMode
    }
    this.layerPatterns[this.activePattern].rightPalletMode = rightPalletMode

    const altPalletModified = (!this.isCustomSolution()) ? this.isAltPalletModified (boxPos, modified, added, rightPalletMode) : false
    if (modified || added || modifiedGroups) {
      console.log ('[DEBUG] shadow modified')
      this.updateShadowCache () // maybe update after populating unique box id?
      this.layerPatterns[this.activePattern].boxPositions!.forEach(p => p.lpbuId = undefined)
      populateUniqueBoxIdsLayerPattern(this.layerPatterns[this.activePattern])
      this.lpcLeft.clearValidationStatus()
      this.lpcRight.clearValidationStatus()
    }

    this.valid = true
    this.saving = false
    if (altPalletModified) {
      this.snackbar.text = String (this.$t ('patternStep.rightPalletModified'))
      this.snackbar.color = 'warning'
      this.snackbar.show = true
      this.snackbar.timeout = 10000
      this.modifiedAltLayers = this.modifiedAltLayers.filter (p => p !== this.activePattern)
    }
  }

  savePatternR(state: PatternEditorState, rightPalletMode: string) {
    if (this.isCustomSolution()) {
      return
    }
    console.log ('[DEBUG] right pattern saving ...')
    const boxPos = [...state.positions]
    const boxGroups = [...state.groups]
    const gripperSections = [...state.gripperSections]
    const pusherGroups = [...state.pusherGroups]
    const ignoreGripperBoxes = [...state.ignoreGripperBoxes]
    const ignoreRotationBoxes = [...state.ignoreRotationBoxes]

    this.layerPatterns[this.activePattern].boxPositionsAlt = boxPos
    this.layerPatterns[this.activePattern].boxGroupsAlt = boxGroups
    this.layerPatterns[this.activePattern].gripperSectionsAlt = gripperSections
    this.layerPatterns[this.activePattern].pusherAlt = pusherGroups
    this.layerPatterns[this.activePattern].ignoreGripperAlt = ignoreGripperBoxes
    this.layerPatterns[this.activePattern].ignoreRotationAlt = ignoreRotationBoxes
    if (rightPalletMode) {
      this.layerPatterns[this.activePattern].rightPalletMode = rightPalletMode
    }
    if (this.layerPatterns[this.activePattern].boxPositionsAlt!.length > 0) {
      this.layerPatterns[this.activePattern].boxPositionsAlt!.forEach(p => p.lpbuId = undefined)
      populateUniqueBoxIds(this.layerPatterns[this.activePattern].boxPositionsAlt!,
          getMaxBoxUID(this.layerPatterns[this.activePattern].boxPositions!))
    }
    this.valid = true
    this.saving = false
  }

  savePalletDisplayRotation(rotation: number) {
    this.pallet.displayRotation = rotation
  }

  private isMachineSettingsOk() {
    return !(this.compatibilityIssues.length > 0 && !this.ignoreMachineSettings)
  }

  private hasValidSequences() {
    return this.hasCompleteSequences() && this.hasAllBoxesInSequences()
  }

  private hasCompleteSequences() {
    return !this.isCustomSolution() || this.layerPatterns.every(lp =>
      this.hasOnlyNonEmptySequences(lp.sequences))
  }

  private hasAllBoxesInSequences() {
    return !this.isCustomSolution() || this.layerPatterns.every(lp =>
      allBoxesInSequence(lp.sequences!, lp.boxPositions!))
  }

  private hasOnlyNonEmptySequences(sequences?: Sequence[]) {
    if (sequences && sequences.length > 0) {
      const sequenceIds = sequences.map(sequence => sequence.id).sort((a, b) => a! - b!)
      if (sequenceIds.some((id, index) => id !== index + 1)) {
        return false
      }
    }
    return !sequences || sequences.every(sequence =>
      sequence.pick != null && sequence.pick.length > 0 &&
      sequence.pick.every(pick => pick.boxesGroup != null && pick.boxesGroup.length > 0))
  }

  private getMirrorIconStyle(mirrorByYAxis: boolean): string {
    const palletRotation = ((this.pallet.displayRotation || 0) % 360 + 360) % 360
    const iconForYAxis = palletRotation % 180 === 90 ? !mirrorByYAxis : mirrorByYAxis
    return iconForYAxis ? '' : 'transform: rotate(90deg)'
  }

  // Watcher to emit valid state to "next" button in stepper
  @Watch ('validAndNotInReorderManualMode')
  private validAndNotInReorderManualModeWatcher(value: boolean) {
    this.$emit ('validate', value)
  }

  @Watch ('activePattern')
  private activePatternWatcher(value: number) {
    this.checkCompatibility()
    this.updateShadowCache ()
    if (this.activeSide === 'L' && value > 0) {
      // check if the previous layer has box positions and this layer is empty
      const previousLayer = this.layerPatterns[value - 1]
      const thisLayer = this.layerPatterns[value]
      if (thisLayer.boxPositions!.length === 0 && previousLayer.boxPositions!.length > 0
          && !(this.isPatternGenerationEnabled && this.selectedStrategy != null)) {
        this.showDefineLayerPatternDialog = true
      }
    }
    this.handleWarningPallet (true)
    this.setLayerIssues()
    this.handleIgnoredPallet()
  }

  @Watch ('activeSide')
  private activeSideWatcher() {
    this.handleWarningPallet (false)
    this.setLayerIssues()
    this.handleIgnoredPallet()
  }

  @Watch('isPatternGenerationEnabled')
  private isPatternGenerationEnabledWatcher() {
    this.initPatternGeneration()
  }

  private layerHasSideIssues(layerPattern: LayerPattern, ignored: boolean = false) {
    if (this.layerNames.indexOf(layerPattern.name!) === this.activePattern) {
      return false
    }
    const layersIssues = this.layerIssues.get(layerPattern.name!)
    const sideIssues = layersIssues ? layersIssues.find(i => i.side === this.activeSide) : null
    const sideHasIssues = ignored ? (sideIssues != null && sideIssues.ignoredIssues) : (sideIssues != null && sideIssues.hasIssue)
    // console.log('sideHasIssues: ', sideHasIssues, ignored, this.activeSide, layerPattern.name, this.activePattern)
    return sideHasIssues
  }

  private toolTipSideIssues(ignored: boolean = false) {
    const side = this.activeSide === 'L' ? this.$t('patternStep.rightSide') : this.$t('patternStep.leftSide')
    const issues = ignored ? this.$t('patternStep.ignoredIssues') : this.$t('patternStep.issues')
    return this.$t('patternStep.layerSideIssues', [side, issues])
  }

  private showWarningIcon(side: string, ignored: boolean = false) {
    if (side === 'L') {
      const issuesLeft = (ignored) ? this.leftHasIgnoredIssues : this.leftHasIssues
      return this.activeSide === 'R' && issuesLeft
    } else {
      const issuesRight = (ignored) ? this.altHasIgnoredIssues : this.altHasIssues
      return this.activeSide === 'L' && issuesRight
    }
  }

  private handleWarningPallet(switchedPattern: boolean) {
    let issuesPatternLeft = false
    let issuesPatternRight = false
    this.altHasIssues = false
    this.leftHasIssues = false
    this.hasLayerIssuesMap.forEach ((value, key) => {
      if (value.some(v =>  v < this.layerPatterns.length)) {
        issuesPatternLeft = true
        this.leftHasIssues = true
      }
      if (value.some (v => v >= this.layerPatterns.length)) {
        issuesPatternRight = true
        this.altHasIssues = true
      }
    })
    // console.log ('handleWarningPallet -> ', issuesPatternLeft, issuesPatternRight)
    if (this.activeSide === 'L' && !issuesPatternLeft && issuesPatternRight && (this.snackbar.show === false || switchedPattern)) {
      // show warning again
      this.showWarningRightPallet()
    } else {
      this.snackbar.show = false
    }
  }

  private handleIgnoredPallet() {
    this.altHasIgnoredIssues = false
    this.leftHasIgnoredIssues = false
    this.hasLayerIgnoredIssuesMap.forEach ((value, key) => {
      if (value.some(v =>  v < this.layerPatterns.length)) {
        this.leftHasIgnoredIssues = true
      }
      if (value.some (v => v >= this.layerPatterns.length)) {
        this.altHasIgnoredIssues = true
      }
    })
  }

  /**
   * checking if our layerpatterns have any boxPositions saved.
   * So our component can know if it's valid in edit-mode
   */
  @Watch('layerPatterns', {deep: true})
  private lpWatcher (patterns: LayerPattern[]) {
    this.checkForLPValue(patterns)
  }

  private created() {
    this.initPatternGeneration()
  }

  private mounted () {
    this.sendPatternGenerationRequest()

    this.checkCompatibility()
    this.checkForLPValue(this.layerPatterns)
    this.parentBus.$on('stepper_next', this.next)
    this.parentBus.$on('stepper_previous', this.previous)
    this.updateShadowCache()
    this.initializeIgnoredIssuesMap()
    this.setLayerIssues()

    const allBoxPositions = [...this.layerPatterns.map(lp => lp.boxPositions).flat(), ...this.layerPatterns.map(lp => lp.boxPositionsAlt).flat()]
    // console.log('allboxes before', JSON.stringify(allBoxPositions))
    if (!allBoxPositions.every(p => p!.lpbuId)) {
      this.setUniqueBoxIds(this.layerPatterns)
    }
    // const allBoxPositionsAfter = [...this.layerPatterns.map(lp => lp.boxPositions).flat(), ...this.layerPatterns.map(lp => lp.boxPositionsAlt).flat()]
    // console.log('allboxes after', JSON.stringify(allBoxPositionsAfter))
  }

  private beforeDestroy () {
    this.parentBus.$off('stepper_next', this.next)
    this.parentBus.$off('stepper_previous', this.previous)
    if (this.isPatternGenerationEnabled) {
      this.$store.dispatch('patterngeneration/disconnectPatternGeneration')
    }
  }

  private next () {
    console.log('[DEBUG] SimpleFormE.next()', JSON.stringify (this.layerPatterns))
    this.normalizeSequenceApproach()
    if (this.hasLayerIssuesMap.get('gripper') && this.hasLayerIssuesMap.get('gripper')!.length > 0) {
      this.canRotateAll = this.lpcLeft.canAllAutoRotate () && this.lpcRight.canAllAutoRotate ()
      this.showConfirmAutoRotate = true
    } else {
      this.$emit('next', this.layerPatterns, this.pallet)
    }
  }

  private confirmAutoRotate() {
    this.showConfirmAutoRotate = false
    this.lpcLeft.autoResolveGripperIssues ()
    this.lpcRight.autoResolveGripperIssues ()
    this.normalizeSequenceApproach()
    setTimeout (() => this.$emit ('next', this.layerPatterns), 1000) // delay to admire the rotation
  }

  private previous() {
    this.$emit ('previous', this.layerPatterns)
  }

  private updateShadowCache() {
    const p = this.layerPatterns[this.activePattern].boxPositions || []
    const g = this.layerPatterns[this.activePattern].boxGroups || []
    this.shadowCache.positions = JSON.parse (JSON.stringify (p))
    this.shadowCache.groups = JSON.parse (JSON.stringify (g))
  }

  private prepareSaveSequence() {
    this.saving = true
  }

  private getPositionsModified(newList: BoxPosition[], oldList: BoxPosition[]): {modified: number[] | null, added: number[] | null} {

    const byId = (a: any, b: any) => {
      return a.id < b.id ? -1 : 1
    }
    // We need to know positions was changed to destroy Alt Groups (in RIGHT pallet)
    const modifiedPositions = []
    for (let i = 0; i < oldList.length; i++) {
      const id = oldList[i].id
      const newPos = newList.find (p => p.id === id)
      // Was position deleted ?
      if (newPos == null) {
        modifiedPositions.push (id!)
        continue
      }
      // Was position modified (x, y, rotation) ?
      if (JSON.stringify (newPos) !== JSON.stringify (oldList[i])) {
        modifiedPositions.push (id!)
      }
    }

    // Did we add new positions?
    const addedPositions = newList.map (q => q.id!).filter (p => !oldList.some (r => r.id === p))

    // const hash1 = JSON.stringify(newList.sort(byId))
    // const hash2 = JSON.stringify(oldList.sort(byId))
    // console.log('[DEBUG] hash1', hash1)
    // console.log('[DEBUG] hash2', hash2)
    // console.log('[DEBUG] hash the same', hash1 === hash2)
    // return hash1 !== hash2

    return {
      modified: modifiedPositions.length > 0 ? modifiedPositions : null,
      added: addedPositions.length > 0 ? addedPositions : null,
    }
  }

  private isGroupsModified(newList: number[][], oldList: number[][]): boolean {
    if (newList.length !== oldList.length) {
      return true
    }
    const hashFunc = (a: number, b: number) => {
      return (a * b) * 1000 + (a + b)
    }
    const byHash = (a: any, b: any) => {
      return hashFunc (a[0], a[1]) < hashFunc (b[0], b[1]) ? -1 : 1
    }
    // if big numbers error
    try {
      const hash1 = JSON.stringify (newList.sort (byHash))
      const hash2 = JSON.stringify (oldList.sort (byHash))
      return hash1 !== hash2
    } catch (e) {
      return true
    }
  }

  // Input params are from LEFT pallet!
  // "alt" is RIGHT pallet
  private isAltPalletModified(boxPos: BoxPosition[], modified: number[] | null, added: number[] | null, rightPalletMode: string | undefined): boolean {
    console.debug ('[DEBUG] isAltPalletModified() modified', JSON.stringify (modified))
    console.debug ('[DEBUG] isAltPalletModified() added', JSON.stringify (added))
    console.debug ('[DEBUG] isAltPalletModified() rightPalletMode', rightPalletMode)
    if (!added && !modified) {
      return false
    }
    const safeBoxGroupsAlt = []
    const safeGripperSectionsAlt = []
    const safePusherGroupAlt = []
    this.altIsModified = false

    // Exclude groups have modified positions
    const boxGroupsAlt = this.layerPatterns[this.activePattern].boxGroupsAlt!
    const gripperSectionsAlt = this.layerPatterns[this.activePattern].gripperSectionsAlt!
    const pusherGroupsAlt = this.layerPatterns[this.activePattern].pusherAlt!
    for (let i = 0; i < boxGroupsAlt.length; i++) {
      const gg = boxGroupsAlt[i]
      // if there is some group contains modified position?
      if (modified && gg.some (g => modified.includes (g))) {
        this.altIsModified = true
        continue
      }
      safeBoxGroupsAlt.push (gg)
      safeGripperSectionsAlt.push (gripperSectionsAlt[i])
      if (pusherGroupsAlt[i] != null) {
        safePusherGroupAlt.push (pusherGroupsAlt[i])
      }
    }
    console.log ('[DEBUG] verifyAltPallet() safeBoxGroupsAlt', JSON.stringify (safeBoxGroupsAlt))
    console.log ('[DEBUG] verifyAltPallet() safeGripperSectionsAlt', JSON.stringify (safeGripperSectionsAlt))
    console.log ('[DEBUG] verifyAltPallet() safePusherGroupAlt', JSON.stringify (safePusherGroupAlt))

    const boxPositionsAlt = this.layerPatterns[this.activePattern].boxPositionsAlt!
    // handle right side box positions according to mode
    if (rightPalletMode && rightPalletMode !== this.defaultRightPalletMode) {
      boxPos = layerTransform.mirrorLayer(this.pallet, boxPos, rightPalletMode === 'mirrorLeftY')
    }
    const altPattern = renumberBoxes (boxPos, this.box, false, safeBoxGroupsAlt, this.boxOrientationOnConveyor) // false == Alt Pallet (right)
    this.updateIgnoreValues (modified, altPattern)
    altPattern.forEach(p => p.lpbuId = undefined) // reset left side lpbuids

    for (const origBoxRight of boxPositionsAlt) {
      const newBoxRight = altPattern.find(b => b.id === origBoxRight.id)
      if (newBoxRight === undefined || origBoxRight.rotation === newBoxRight.rotation) {
        continue
      }
      if (Math.abs(origBoxRight.rotation! - newBoxRight.rotation!) === 180) {
        // only 180 rotation diff is allowed on right side
        console.log('[DEBUG] verifyAltPallet() maintain rotation for box id: ', newBoxRight.id)
        newBoxRight.rotation = origBoxRight.rotation
      }
    }

    this.layerPatterns[this.activePattern].boxPositionsAlt = altPattern
    this.layerPatterns[this.activePattern].boxGroupsAlt = safeBoxGroupsAlt
    this.layerPatterns[this.activePattern].gripperSectionsAlt = safeGripperSectionsAlt
    this.layerPatterns[this.activePattern].pusherAlt = safePusherGroupAlt

    // because alt boxes where renumbered
    this.layerPatterns[this.activePattern].manualOrderAlt = false
    this.layerPatternComponentKeyAlt++
    return this.altIsModified
  }

  private updateIgnoreValues(modified: number[] | null, altPattern: BoxPosition[]) {
    // only update ignore values if box has been modified/removed
    if (!modified) {
      return
    }
    const ignoreGripperAlt = this.layerPatterns[this.activePattern].ignoreGripperAlt!
    const ignoreRotationAlt = this.layerPatterns[this.activePattern].ignoreRotationAlt!
    const safeIgnoreGripperAlt: number[] = []
    const safeIgnoreRotationAlt: number[] = []
    ignoreGripperAlt.forEach (i => safeIgnoreGripperAlt.push (i))
    ignoreRotationAlt.forEach (i => safeIgnoreRotationAlt.push (i))

    for (const id of modified!) {
      if (!altPattern.map (bp => bp.id).includes (id)) {
        const index = safeIgnoreGripperAlt.indexOf (id)
        if (index > -1) {
          safeIgnoreGripperAlt.splice (index, 1)
        }
        const index2 = safeIgnoreRotationAlt.indexOf (id)
        if (index2 > -1) {
          safeIgnoreRotationAlt.splice (index2, 1)
        }
      }
    }
    this.layerPatterns[this.activePattern].ignoreGripperAlt = safeIgnoreGripperAlt
    this.layerPatterns[this.activePattern].ignoreRotationAlt = safeIgnoreRotationAlt
  }

  private getInitPositions(side: string) {
    const layerPatterns = this.layerPatterns
    if (layerPatterns.length > 0) {
      const tmp = side === 'R' ? layerPatterns[this.activePattern].boxPositionsAlt :
          layerPatterns[this.activePattern].boxPositions
      return JSON.parse (JSON.stringify (tmp))
    }
  }

  private getInitGripperSections(side: string) {
    const layerPatterns = this.layerPatterns
    if (layerPatterns.length > 0) {
      const sections = side === 'R' ? layerPatterns[this.activePattern].gripperSectionsAlt :
          layerPatterns[this.activePattern].gripperSections
      if (sections) {
        return JSON.parse (JSON.stringify (sections))
      }
      return null
    }
  }

  private getInitBoxGroups(side: string) {
    const layerPatterns = this.layerPatterns
    if (layerPatterns.length > 0) {
      const boxGroups = side === 'R' ? layerPatterns[this.activePattern].boxGroupsAlt :
          layerPatterns[this.activePattern].boxGroups
      if (boxGroups) {
        return JSON.parse (JSON.stringify (boxGroups))
      }
      return null
    }
  }

  private getInitPusherGroups(side: string) {
    const layerPatterns = this.layerPatterns
    if (layerPatterns.length > 0) {
      const pusherGroups = side === 'R' ? layerPatterns[this.activePattern].pusherAlt : layerPatterns[this.activePattern].pusher
      if (!pusherGroups) {
        return null
      }

      // temp fix for faulty patterns
      const groups = side === 'R' ? layerPatterns[this.activePattern].boxGroupsAlt : layerPatterns[this.activePattern].boxGroups
      if (groups && (groups.length < pusherGroups.length)) {
        const start = pusherGroups.length - groups.length
        const pusherGroupsMod = pusherGroups.slice (start)
        console.log ('[DEBUG] getInitPusherGroups - corrected pusherGroups: ', JSON.stringify (pusherGroupsMod))
        return JSON.parse (JSON.stringify (pusherGroupsMod))
      }
      if (pusherGroups.length > 1 && pusherGroups.every(pg => pg === null)) {
        console.log ('[DEBUG] getInitPusherGroups - with null values: ', JSON.stringify (pusherGroups))
        pusherGroups.length = 0
      }
      return JSON.parse (JSON.stringify (pusherGroups))
    }
  }

  private getInitIgnoreGripperList(side: string) {
    const layerPatterns = this.layerPatterns
    if (layerPatterns.length > 0) {
      const ignoreList = side === 'R' ? layerPatterns[this.activePattern].ignoreGripperAlt :
          layerPatterns[this.activePattern].ignoreGripper
      if (ignoreList) {
        return JSON.parse (JSON.stringify (ignoreList))
      }
      return null
    }
  }

  private getInitIgnoreRotationList(side: string) {
    const layerPatterns = this.layerPatterns
    if (layerPatterns.length > 0) {
      const ignoreList = side === 'R' ? layerPatterns[this.activePattern].ignoreRotationAlt :
          layerPatterns[this.activePattern].ignoreRotation
      if (ignoreList) {
        return JSON.parse(JSON.stringify (ignoreList))
      }
      return null
    }
  }

  private getInitialRightPalletMode() {
    const layerPatterns = this.layerPatterns
    if (layerPatterns.length > 0 && layerPatterns[this.activePattern].rightPalletMode) {
      return layerPatterns[this.activePattern].rightPalletMode
    }
    return this.defaultRightPalletMode
  }

  private getBoxForLayerPatternComponent() {
    const lpcBox = {
      length: this.box.length,
      width: this.box.width,
      height: this.box.height,
      lengthMargin: this.box.lengthMargin ? this.box.lengthMargin : 0,
      widthMargin: this.box.widthMargin ? this.box.widthMargin : 0
    }
    return lpcBox
  }

  private snackBarHandler(state: boolean, color: string, text: string) {
    this.snackbar.show = state
    this.snackbar.color = color
    this.snackbar.text = text
  }

  private getLayerPatternName(index: number): string {
    const lp = this.layerPatterns[index]
    return (lp && lp.name) ? lp.name : ''
  }

  private createRotatedLayerPattern() {
    const previousLayerBoxPositions = this.layerPatterns[this.activePattern - 1].boxPositions
    const newBoxPositions = this.rotatePositions (previousLayerBoxPositions)

    // this.layerPatterns[this.activePattern].boxPositions = newBoxPositions
    this.savePattern ({
      positions: newBoxPositions,
      groups: [],
      gripperSections: [],
      pusherGroups: [],
      ignoreGripperBoxes: [],
      ignoreRotationBoxes: []
    })

    this.forceLayerPatternComponentReRender ()
    this.showDefineLayerPatternDialog = false
  }

  private rotatePositions(originalPositions?: BoxPosition[]): BoxPosition[] {
    if (!originalPositions) {
      console.log ('[ERROR] layer box positions are not defined')
      return []
    }
    let rotatedBoxPositions = layerTransform.rotateLayer180 (this.pallet, originalPositions)
    rotatedBoxPositions = renumberBoxes (rotatedBoxPositions, this.box, true, [], this.boxOrientationOnConveyor)
    return rotatedBoxPositions
  }

  private mirrorLayer(mirrorByYAxis: boolean) {
    const previousLayerBoxPositions = this.layerPatterns[this.activePattern - 1].boxPositions
    const newBoxPositions = this.mirrorPositions(mirrorByYAxis, previousLayerBoxPositions)
    this.savePattern ({
      positions: newBoxPositions,
      groups: [],
      gripperSections: [],
      pusherGroups: [],
      ignoreGripperBoxes: [],
      ignoreRotationBoxes: []
    })

    this.forceLayerPatternComponentReRender ()
    this.showDefineLayerPatternDialog = false
  }

  private applyRightPalletMode(mode: string) {
    const leftBoxPositions = this.layerPatterns[this.activePattern].boxPositions
    let newBoxPositions = leftBoxPositions!
    if (mode !== this.defaultRightPalletMode) {
      newBoxPositions = this.mirrorPositions('mirrorLeftY' === mode, leftBoxPositions)
    }
    newBoxPositions = renumberBoxes(newBoxPositions, this.box, false, [], this.boxOrientationOnConveyor)
    this.savePatternR ({
      positions: newBoxPositions,
      groups: [],
      gripperSections: [],
      pusherGroups: [],
      ignoreGripperBoxes: [],
      ignoreRotationBoxes: []
    }, mode)
    this.forceLayerPatternComponentReRender ()
  }

  private mirrorPositions(mirrorByYAxis: boolean, originalPositions?: BoxPosition[]) {
    if (!originalPositions) {
      console.log ('[ERROR] layer box positions are not defined')
      return []
    }
    let mirroredBoxPositions = layerTransform.mirrorLayer(this.pallet, originalPositions, mirrorByYAxis)
    mirroredBoxPositions = renumberBoxes(mirroredBoxPositions, this.box, true, [], this.boxOrientationOnConveyor)
    return mirroredBoxPositions
  }

  private forceLayerPatternComponentReRender() {
    this.layerPatternComponentKey++
    this.layerPatternComponentKeyAlt++
  }

  /**
   * Validation method that checks if pattern "A", "B" or "Z" has any value
   */
  private checkForLPValue(patterns: LayerPattern[]) {
    this.valid = patterns.some (p => p.boxPositions!.length > 0) && this.isPatternOk ()
    this.setNextToolTip ()
  }

  private handleImageCollection(dataUrl: string) {
    this.$emit ('handleImage', dataUrl, this.activePattern)
  }

  private handleAltLayerModified(options: {side: string, id: number}) {
    if (options.side === 'R' && !this.modifiedAltLayers.includes (options.id)) {
      this.modifiedAltLayers.push (options.id)
    }
    // console.log('[DEBUG] modified handler', this.modifiedAltLayers)
  }

  private handleReorderManuallyActivated(value: boolean) {
    this.reorderManuallyMode = !!value
  }

  private handleLayerIssues(value: boolean, layerId: number, type: string) {
    if (!this.hasLayerIssuesMap.has(type) && value) {
      this.hasLayerIssuesMap.set(type, [layerId])
    } else {
      this.hasLayerIssuesMap.forEach ((v, k) => {
        if (k === type) {
          const index = v.indexOf (layerId)
          if (value && index === -1) {
            v.push (layerId)
          }
          if (!value && index > -1) {
            v.splice (index, 1)
          }
        }
      })
    }
    this.setNextToolTip ()
    this.layerIssues = updateLayerIssues(this.layerIssues, this.hasLayerIssuesMap, this.hasLayerIgnoredIssuesMap, this.layerPatterns, layerId)
    this.handleWarningPallet (false)
  }

  private handleLayerIssuesR(value: boolean, layerId: number, type: string) {
    this.handleLayerIssues (value, layerId + 3, type) // (layer id + 3) as id for right side
  }

  private initializeIgnoredIssuesMap() {
    for (const layerPattern of this.layerPatterns) {
      const layerId = this.layerNames.indexOf(layerPattern.name!.toString())
      if (layerPattern.ignoreGripper!.length > 0) {
        this.updateIgnoredLayerIssuesMap(true, layerId, 'gripper')
      }
      if (layerPattern.ignoreRotation!.length > 0) {
        this.updateIgnoredLayerIssuesMap(true, layerId, 'rotation')
      }
      if (layerPattern.ignoreGripperAlt!.length > 0) {
        this.updateIgnoredLayerIssuesMap(true, layerId + 3, 'gripper')
      }
      if (layerPattern.ignoreRotationAlt!.length > 0) {
        this.updateIgnoredLayerIssuesMap(true, layerId + 3, 'rotation')
      }
    }
  }

  private setNextToolTip() {
    let toolTipText = ''
    if (!this.valid) {
      if (!this.hasCompleteSequences()) {
        toolTipText = String (this.$t ('patternStep.customSolutionInvalidSequences'))
      } else if (!this.hasAllBoxesInSequences()) {
        toolTipText = String (this.$t ('patternStep.customSolutionSelectionRequired'))
      } else {
        toolTipText = (this.isMachineSettingsOk()) ? String (this.$t ('patternStep.emptyPattern')) : String (this.$t ('patternStep.compatibilityWarning1'))
      }
    }
    this.$emit ('nextToolTip', toolTipText)
  }

  private showWarningRightPallet() {
    this.snackbar.text = String (this.$t ('patternStep.rightPalletCheckIssues'))
    this.snackbar.color = 'warning'
    this.snackbar.show = true
    this.snackbar.timeout = 10000
  }

  private checkCompatibility() {
    if (!this.pallet.layerPatterns) {
      return
    }
    this.compatibilityIssues = checkPatternCompatibility(this.pallet.layerPatterns, this.machineSettings, this.programSettings.robotType!, true)
    if (this.compatibilityIssues.length > 0) {
      this.showSettingsWarning = true
    }
  }

  private confirmSettingsWarning() {
    // console.log('confirmSettingsWarning.....')
    this.showSettingsWarning = false
    this.ignoreMachineSettings = true
    this.checkForLPValue (this.layerPatterns)

    // reset grouping info from pattern in child components
    this.lpcLeft.resetGroups (this.compatibilityIssues)
    this.lpcRight.resetGroups (this.compatibilityIssues)
  }

  private getCompatibilityWarningText() {
    let settings = ''
    if (this.compatibilityIssues.includes ('pusher')) {
      settings = 'Pusher'
    }
    if (this.compatibilityIssues.includes ('sections')) {
      settings = ((settings.length > 0) ? settings + ', ' : '') + `${this.$t('patternStep.compatibilityGripper')}`
    }
    if (this.compatibilityIssues.includes('doubleplace')) {
      settings = ((settings.length > 0) ? settings + ', ' : '') + `${this.$t('patternStep.compatibilityDoublePlace')}`
    }
    return `${ String(this.$t ('patternStep.compatibilityWarning2')) } ${ settings }.`
  }

  private getColorRight() {
    if (this.activeSide === 'R') {
      return 'primary'
    }
    if (this.activeSide === 'L') {
      if (this.altHasIssues) {
        return '#ff0039'
      } else if (this.altHasIgnoredIssues) {
        return '#ff9900'
      }
    }
    return ''
  }

  private getColorLeft() {
    if (this.activeSide === 'L') {
      return 'primary'
    }
    if (this.activeSide === 'R') {
      if (this.leftHasIssues) {
        return '#ff0039'
      } else if (this.leftHasIgnoredIssues) {
        return '#ff9900'
      }
    }
    return ''
  }

  private updateIgnoredLayerIssuesMap(value: boolean, layerId: number, type: string = 'gripper') {
    if (!this.hasLayerIgnoredIssuesMap.has (type) && value) {
      this.hasLayerIgnoredIssuesMap.set (type, [layerId])
    } else {
      this.hasLayerIgnoredIssuesMap.forEach ((v, k) => {
        if (k === type) {
          const index = v.indexOf (layerId)
          if (value && index === -1) {
            v.push (layerId)
          }
          if (!value && index > -1) {
            v.splice (index, 1)
          }
        }
      })
    }
  }

  private handleIgnoredLayerIssues(value: boolean, layerId: number, type: string = 'gripper') {
    this.updateIgnoredLayerIssuesMap(value, layerId, type)
    this.handleIgnoredPallet()
    this.layerIssues = updateLayerIssues(this.layerIssues, this.hasLayerIssuesMap, this.hasLayerIgnoredIssuesMap, this.layerPatterns, layerId)
  }

  private handleIgnoredLayerIssuesR(value: boolean, layerId: number, type: string = 'gripper') {
    const layerIdR = layerId + 3
    this.handleIgnoredLayerIssues(value, layerIdR, type)
  }

  private setUniqueBoxIds(layerPatterns: LayerPattern[]) {
    const lps = JSON.parse(JSON.stringify(layerPatterns))
    for (const lp of lps) {
      populateUniqueBoxIdsLayerPattern(lp)
    }
    this.layerPatterns = lps
  }

  private getValidationResult() {
    const lpName = getLayerPatternNameFromValidationDetails(this.palletPattern)
    if (lpName === this.getLayerPatternName(this.activePattern)) {
      return {
        lpbuId: this.palletPattern.validationDetails!.lpbuId!,
        layerNo: this.palletPattern.validationDetails!.layerNo!
      }
    }
    return {}
  }

  private isCustomSolution() {
    return RobotTypeEnum.CUSTOM_SOLUTION === this.programSettings.robotType
  }

  private withDefaultSequenceApproach(sequences: Sequence[]): Sequence[] {
    return sequences.map(sequence => ({
      ...sequence,
      approachAngle: sequence.approachAngle === 0 || sequence.approachAngle
          ? sequence.approachAngle
          : this.defaultApproachAngle(),
      approachDistance: sequence.approachDistance === 0 || sequence.approachDistance
          ? sequence.approachDistance
          : this.defaultApproachDistance(),
      customInfeedRotation: getCustomInfeedRotation(sequence)
    }))
  }

  private normalizeSequenceApproach() {
    if (!this.isCustomSolution()) {
      return
    }
    this.layerPatterns.forEach(layerPattern => {
      if (layerPattern.sequences) {
        layerPattern.sequences = this.withDefaultSequenceApproach(layerPattern.sequences)
      }
    })
  }

  private defaultApproachAngle(): number {
    const angle = this.programSettings.approachAngle
    return angle === 0 || angle ? Math.floor(Number(angle)) : 45
  }

  private defaultApproachDistance(): number {
    const distance = this.programSettings.approachDistance
    return distance === 0 || distance ? Math.floor(Number(distance)) : 200
  }

  private getInitialSequences() {
    if (!this.isCustomSolution()) {
      return null
    }
    const layerPatterns = this.layerPatterns
    if (layerPatterns.length > 0) {
      const sequences = layerPatterns[this.activePattern].sequences
      if (sequences) {
        return JSON.parse (JSON.stringify (sequences))
      }
      return null
    }
  }

  private setLayerIssues() {
    if (isRI20(this.programSettings.robotType!)) { // currently layer issues are RI20 specific
      this.layerIssues = setLayerIssuesValues(this.layerPatterns, this.palletPattern, this.machineSettings)
    }
  }

  private initPatternGeneration() {
    if (!this.isPatternGenerationEnabled) {
      if (this.isPatternGenConnected) {
        this.$store.dispatch('patterngeneration/disconnectPatternGeneration')
      }
      console.debug('Skip Pattern Generation connection - not enabled')
      return
    }
    if (this.isPatternGenerationEnabled && this.isPatternGenConnected) {
      console.debug('Skip Pattern Generation connection - already connected')
      return
    }
    console.debug('Initialize Pattern Generation connection: ', this.settings.pgParams!.host, this.settings.pgParams!.port)
    this.$store.dispatch('patterngeneration/connectPatternGeneration', `ws://${this.settings.pgParams!.host}:${this.settings.pgParams!.port}`)
  }

  private sendPatternGenerationRequest() {
    if (this.isPatternGenerationEnabled) {
      // clear current response
      if (this.patternGenResponse != null) {
        this.$store.commit('patterngeneration/SET_RESPONSE', null)
      }
      const isSSL = this.palletPattern.programSettings!.boxOrientationOnConveyor === 'SHORT_SIDE_LEADING'
      const message: GeneratePatternPlanMessage = {
        type: GeneratePatternPlanMessageTypeEnum.GENERATEPATTERNPLAN,
        boxLeading: isSSL ? BoxLeadingMode.SHORTSIDE : BoxLeadingMode.LONGSIDE,
        box: {
          length: isSSL ? this.palletPattern.box!.length! : this.palletPattern.box!.width!,
          width: isSSL ? this.palletPattern.box!.width! : this.palletPattern.box!.length!,
          height: this.palletPattern.box!.height!
        },
        pallet: {
          length: this.palletPattern.pallet!.length!,
          width: this.palletPattern.pallet!.width!,
          max_height: 1800,
          overhang_top: this.palletPattern.pallet!.overhangT,
          overhang_bottom: this.palletPattern.pallet!.overhangB,
          overhang_left: this.palletPattern.pallet!.overhangL,
          overhang_right: this.palletPattern.pallet!.overhangR
        }
      }
      this.$store.dispatch('patterngeneration/sendRequest', message)
    }
  }

  private setSelectedStrategy(value: string) {
    this.selectedStrategy = value
  }
}
